import API from "./API"

const fertPricesEndpoint = "/fertilizer-prices/"

const listAllFertilizer = () => API.get(fertPricesEndpoint)

export default {
  listAllFertilizer,
}
